import React from 'react';
import PropTypes from 'prop-types';

import { StyledInput, StyledSwitch, StyledToggle, StyledLabel } from './index.styles';

export const Switch = ({
    className,
    defaultChecked,
    onChange,
    disabled,
    label,
    defaultValue,
    ...otherProps
}) => {
    const inputRef = React.useRef(null);

    const handleOnClick = () => {
        inputRef.current.click();
    };

    return (
        <StyledSwitch className={className}>
            <StyledInput
                ref={inputRef}
                onChange={onChange}
                defaultChecked={defaultChecked}
                disabled={disabled}
                {...otherProps}
            />
            <StyledToggle disabled={disabled} onClick={handleOnClick} />
            {label ? (
                <StyledLabel disabled={disabled} onClick={handleOnClick}>
                    {label}
                </StyledLabel>
            ) : null}
        </StyledSwitch>
    );
};

Switch.propTypes = {
    className: PropTypes.string,
    defaultChecked: PropTypes.bool,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
};

Switch.defaultProps = {
    className: '',
    defaultChecked: false,
    disabled: false,
    onChange: () => undefined,
    label: undefined,
    defaultValue: '',
};

export default Switch;
